import Overlay from './Overlay';

export type { IOverlayProps } from './Overlay.types';
export default Overlay;
